export default __webpack_public_path__ + "static/media/chim3.fa198549.jpg";